import React, { useState, useEffect } from "react";
import "./ExplorebyTopic.css";
import data from "./ExplorebyTopic.json";

const ExplorebyTopic = () => {
  const [activeCategory, setActiveCategory] = useState("Agentic");
  const [activeSubcategory, setActiveSubcategory] = useState("All");
  const [categoryCourses, setCategoryCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);

  const categoryIcons = {
    Agentic: "images/AIAcademy/Agentic-Icon.png",
    AI: "images/AIAcademy/AI-Icon.png",
    "Gen AI": "images/AIAcademy/GenAI-Icon.png",
    Platform: "images/AIAcademy/Platform-Icon.png",
  };

  useEffect(() => {
    const forCat = data.courses.filter((c) => c.category === activeCategory);
    setCategoryCourses(forCat);

    if (forCat.length > 1) {
      setActiveSubcategory("All");
    } else if (forCat.length === 1) {
      setActiveSubcategory(forCat[0].subcategory);
    } else {
      setActiveSubcategory("All");
    }
  }, [activeCategory]);

  useEffect(() => {
    let filtered = categoryCourses;
    if (activeSubcategory && activeSubcategory !== "All") {
      filtered = filtered.filter((c) => c.subcategory === activeSubcategory);
    }
    setFilteredCourses(filtered);
  }, [categoryCourses, activeSubcategory]);

  const presentSubcategories = [...new Set(categoryCourses.map((c) => c.subcategory))];

  return (
    <div className="agentic-ai-container-Topic">
      <div className="dashboard-container">
        <aside className="sidebar">
          <h2 className="sidebar-title">Category</h2>
          {data.categories.map((cat) => (
            <div
              key={cat}
              className={`category-item ${cat === activeCategory ? "active" : ""}`}
              onClick={() => setActiveCategory(cat)}
            >
              <div className="category-icon">
                <img src={categoryIcons[cat]} alt={`${cat} icon`} className="category-img" />
              </div>
              <span className="category-name">{cat}</span>
            </div>
          ))}
        </aside>

        <main className="main-content">
            {presentSubcategories.length > 1 ? (
            <>
                <h2 className="content-title">Subcategory</h2>
                <nav className="subcategory-nav">
                {data.subcategories
                    .filter(
                    (sub) =>
                        sub === "All" || presentSubcategories.includes(sub)
                    )
                    .map((sub) => (
                    <button
                        key={sub}
                        className={`nav-tab ${sub === activeSubcategory ? "active" : ""}`}
                        onClick={() => setActiveSubcategory(sub)}
                    >
                        {sub}
                    </button>
                    ))}
                </nav>
            </>
            ) : (
            presentSubcategories.length === 1 && (
                <h2 className="content-title">{presentSubcategories[0]}</h2>
            )
            )}

          <div className="courses-grid">
            {filteredCourses.length > 0 ? (
              filteredCourses.map((course, idx) => (
                <div key={idx} className="course-card">
                  <h5 className="course-title">
                    <a href={course.url} target="_blank">{course.title}</a>
                  </h5>
                  <div className="course-meta">
                    <span className="meta-item">
                      <img src="images/AIAcademy/course-icon.png" alt="Type" className="meta-icon" />
                      {course.type}
                    </span>
                    <span className="meta-item">
                      <img src="images/AIAcademy/duration-Icon.png" alt="Duration" className="meta-icon" />
                      {course.duration}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-course">No courses available.</p>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default ExplorebyTopic;